import { useEffect, useMemo, useRef, useState } from 'react';
import GridTable from '../../component/grid/GridTable';
import { defaultGridData } from '../../module/component/TableBoxModule';
import SearchButtonBox from '../../component/buttons/SearchButtonBox';
import SelectionBox from '../../component/SelectionBox';
import InputBox from '../../component/InputBox';
import { InfoTxt, ModalHeader } from '../../component/ModalRef';
import { CODE_GROUP_ID } from '../../constant/Constant';
import CodeUtil from '../../util/CodeUtil';
import { useDispatch } from 'react-redux';
import { actionInit, actionSearch } from '../../module/modal/SubjectCodeSearchModule';

const SubjectCodeSearchModal = ({ callback, modalRef }) => {
    const gridRef = useRef(null);
    const dispatch = useDispatch();
    const [subjectNm, setSubjectNm] = useState('');
    const [subjectTypeCd, setSubjectTypeCd] = useState('');

    const onKeyDown = (e) => {
        if (e.key == 'Enter') {
            onClickSearch();
        }
    };

    useEffect(() => {
        gridRef.current.setColumns(columns);
        gridRef.current.setRowDoubleClick(() => {
            return function (params) {
                callback(params.row.subjectId, params.row.subjectNm, params.row.subjectTypeCd);
                modalRef.current.close();
            };
        });

        onClickSearch();

        return () => {
            dispatch(actionInit());
        };
    }, []);

    const onClickSearch = () => {
        var params = {
            subjectTypeCd,
            subjectNm,
            page: defaultGridData.page,
            pageSize: 10,
        };
        gridRef.current.setChagnePageInfo(() => {
            return function (page, pageSize) {
                params = {
                    ...params,
                    page,
                    pageSize,
                };
                dispatch(actionSearch({ params }));
            };
        });
        dispatch(actionSearch({ params }));
    };

    const columns = useMemo(
        () => [
            {
                field: 'subjectTypeCd',
                headerName: '과정구분',
                headerAlign: 'center',
                align: 'center',
                tooltip: true,
                flex: 15,
                renderCell: (params) => CodeUtil.getCodeName(CODE_GROUP_ID.SUBJECT_TYPE, params.row.subjectTypeCd),
            },
            {
                field: 'subjectNm',
                headerName: '교과목',
                headerAlign: 'center',
                align: 'left',
                tooltip: true,
                flex: 30,
            },
        ],
        [],
    );

    return (
        <>
            <ModalHeader title='교과목 조회' modalRef={modalRef} />
            <div className='SubjectCodeSearchModal'>
                <div className='modal-body'>
                    <div className='con-inner'>
                        <InfoTxt infoTxt='입력하실 교과목을 조회하여 더블클릭해주세요.' />
                        <div className='pop-up-search-box'>
                            <div className='form-box-row'>
                                <SelectionBox
                                    size='large'
                                    title='과정구분'
                                    options={CodeUtil.getCodes(CODE_GROUP_ID.SUBJECT_TYPE)}
                                    value={subjectTypeCd}
                                    onChange={(e) => setSubjectTypeCd(e.target.value)}
                                    onKeyDown={(e) => onKeyDown(e)}
                                />
                                <InputBox
                                    size='large'
                                    title='교과목'
                                    value={subjectNm}
                                    onChange={(e) => setSubjectNm(e.target.value)}
                                    onKeyDown={(e) => onKeyDown(e)}
                                />
                            </div>
                            <div className='search-btn'>
                                <SearchButtonBox title='교과목조회' onClick={(e) => onClickSearch(e)} />
                            </div>
                        </div>
                        <div className='pop-up-table'>
                            <GridTable hideHeader ref={gridRef} selector={(state) => state.subjectCodeSearchState} />
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};

export default SubjectCodeSearchModal;
